import React from "react";
import { FaEnvelope, FaHome, FaIndustry, FaPhoneAlt, FaStore } from "react-icons/fa";
import { MdElectricBolt, MdInfoOutline } from 'react-icons/md';

const Newtariffclassification = () => {
  const years = ['2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024'];

  const tariffData = [
    { class: 'R11111', values: [4.00, 4.00, 4.00, 4.00, 4.00, 4.00, 4.00, 4.00, 4.00, 4.00] },
    { class: 'R2S', values: [14.82, 24.08, 31.27, 31.26, 30.98, 30.88, 27.29, 24.49, 24.34, 24.14] },
    { class: 'R2T', values: [14.82, 24.45, 34.40, 34.40, 34.08, 33.97, 30.02, 26.94, 26.78, 26.56] },
    { class: 'R3', values: [26.52, 38.56, 40.46, 40.46, 40.08, 39.96, 35.32, 31.69, 31.50, 31.24] },
    { class: 'R4', values: [26.52, 38.56, 40.46, 40.46, 40.08, 39.96, 35.32, 31.69, 31.50, 31.24] },
    { class: 'C1S', values: [20.72, 33.87, 34.90, 34.90, 34.58, 34.47, 30.46, 27.34, 27.17, 26.95] },
    { class: 'C1T', values: [20.72, 34.19, 36.27, 36.27, 35.94, 35.83, 31.66, 28.41, 28.24, 28.01] },
    { class: 'C2', values: [24.65, 40.67, 38.11, 38.11, 37.76, 37.64, 33.27, 29.85, 29.67, 29.43] },
    { class: 'C3', values: [24.65, 40.67, 38.11, 38.11, 37.76, 37.64, 33.27, 29.85, 29.67, 29.43] },
    { class: 'D 1S', values: [19.89, 32.51, 35.62, 35.62, 35.29, 35.18, 31.09, 27.90, 27.73, 27.50] },
    { class: 'D 1T', values: [19.89, 32.82, 37.94, 37.94, 37.59, 37.47, 33.12, 29.72, 29.54, 29.30] },
    { class: 'D2', values: [25.84, 38.56, 39.29, 39.29, 38.92, 38.80, 34.29, 30.77, 30.59, 30.34] },
    { class: 'D3', values: [25.84, 38.56, 37.71, 39.29, 38.92, 38.80, 34.29, 30.77, 30.59, 30.34] },
    { class: 'A1S', values: [19.04, 31.12, 33.00, 33.00, 32.70, 32.59, 28.81, 25.85, 25.69, 25.48] },
    { class: 'A1T', values: [19.04, 31.42, 33.97, 33.97, 33.66, 33.55, 29.66, 26.61, 26.45, 26.24] },
    { class: 'A2', values: [19.04, 31.42, 35.27, 35.27, 34.95, 34.84, 30.79, 27.63, 27.46, 27.24] },
    { class: 'A3', values: [19.04, 31.42, 35.27, 35.27, 34.95, 34.84, 30.79, 27.63, 27.46, 27.24] },
    { class: 'L1', values: [19.62, 32.07, 36.26, 36.26, 35.93, 35.81, 31.65, 28.40, 28.23, 28.00] },
  ];

  return (
    <div className="w-full min-h-screen bg-white font-sans">
      {/* Hero Section */}
      <div className="relative bg-[#14532d] text-white py-12 md:py-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}> 
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="lg:w-2/3">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight uppercase tracking-tight">
              Tariff & <span className="text-yellow-400">Classification</span>
              </h1>
              <div className="w-20 h-1.5 bg-yellow-400 rounded-full mb-6"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 md:py-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start mb-8">
          <div className="lg:col-span-12">
            <div className="relative rounded-xl overflow-hidden shadow-xl border-4 border-white ring-1 ring-gray-100 mb-6">
              <img
                src="/images/objectives-1.jpg"
                alt="Quality Living with BEDC"
                className="w-full h-auto object-cover max-h-[350px]"
              />
            </div>
          </div>

          <div className="lg:col-span-12">
            <div className="bg-black text-white p-4 sm:p-6 md:p-8 mb-6 shadow-xl rounded-xl md:rounded-2xl border-l-[6px] md:border-l-[8px] border-green-700 relative overflow-hidden group">
              <div className="absolute top-0 right-0 w-64 h-64 bg-green-700/10 rounded-full -mr-32 -mt-32 group-hover:scale-110 transition-transform duration-700"></div>
              <p className="text-base sm:text-lg md:text-xl font-black uppercase mb-3 tracking-tighter relative z-10">Dear BEDC Customer,</p>
              <p className="text-xs sm:text-sm md:text-base font-medium leading-relaxed opacity-80 relative z-10">
                Based on the NERC approved tariff structure, find below
                key unique points explaining the implication of the tariff
                regime effective from <span className="text-yellow-400 font-black italic">1st February 2016</span>.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-8">
              {[
                { title: "Fixed Charge Removal", desc: "The fixed charge component has been abolished. Customers are kings and winners." },
                { title: "Energy Charge", desc: "Across all classes, rates will steadily decline over a 10-year period." },
                { title: "Sub-Categories", desc: "Customers with lower earning power are now properly categorized with approved rates." },
                { title: "Consumption Control", desc: "Switch off appliances when not in use to manage your energy charges." },
                { title: "Improved Service", desc: "Faster complaint resolution, better metering, and reduced estimated billing." },
                { title: "Prompt Payment", desc: "Enabled BEDC to service customers effectively across Edo, Delta, Ekiti, and Ondo." },
              ].map((item, idx) => (
                <div key={idx} className="bg-white p-4 sm:p-5 rounded-xl border border-gray-100 hover:border-green-700 hover:shadow-lg transition-all duration-300 group">
                  <h4 className="text-sm sm:text-base font-black uppercase text-black mb-2 tracking-tight group-hover:text-green-700 transition-colors">{item.title}</h4>
                  <p className="text-gray-500 font-medium leading-relaxed text-xs sm:text-sm">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Customer Classification Table */}
        <div className="mb-8">
          <h2 className="text-lg sm:text-xl md:text-2xl font-black text-black mb-6 uppercase tracking-tighter text-center">
            Customer <span className="text-green-700">Classification</span>
          </h2>

          <div className="bg-white rounded-xl md:rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
            <div className="grid grid-cols-12 bg-black text-white text-[10px] font-black uppercase tracking-widest hidden md:grid">
              <div className="col-span-4 p-4 border-r border-white/10">Category</div>
              <div className="col-span-4 p-4 border-r border-white/10">Description</div>
              <div className="col-span-4 p-4">Remarks</div>
            </div>

            <Section
              icon={<FaHome />}
              title="Residential"
              rows={[
                ["R1", "Not Applicable"],
                ["R2S", "Single"],
                ["R2T", "Three (3) Phase"],
                ["R3", "LV Maximum demand"],
                ["R4", "HV Maximum demand (11/33 kV)"],
              ]}
              remark="A consumer who uses his premises exclusively as a residence – house, flat or multi-storey house."
            />

            <Section
              icon={<FaStore />}
              title="Commercial"
              rows={[
                ["C1S", "Single Phase"],
                ["C1T", "Three (3) Phase"],
                ["C2", "LV Maximum demand"],
                ["C3", "HV Maximum demand (11/33 kV)"],
              ]}
              remark="A consumer who uses his premises for any purpose other than exclusively as a residence or as a factory for manufacturing goods."
            />

            <Section
              icon={<FaIndustry />}
              title="Industrial"
              rows={[
                ["D1S", "Single Phase"],
                ["D1T", "Three (3) Phase"],
                ["D2", "LV Maximum demand"],
                ["D3", "HV Maximum demand (11/33 kV)"],
              ]}
              remark="A consumer who uses his premises for manufacturing goods including welding and ironmongery. Also includes agriculture, agro-allied industries, water boards, religious houses, government and teaching hospitals, government research institutes and educational establishments."
            />
          </div>
        </div>

        {/* Tariff Table Section */}
        <div className="bg-gray-50 p-4 sm:p-6 rounded-xl md:rounded-2xl border border-gray-100 shadow-sm mb-8">
          <div className="bg-white rounded-xl shadow-xl overflow-hidden">
            <div className="bg-black px-5 sm:px-6 py-4 flex flex-col md:flex-row justify-between items-center gap-4">
              <div className="flex items-center gap-3">
                <div className="p-2.5 bg-yellow-400 rounded-xl text-black shadow-md">
                  <MdElectricBolt size={22} />
                </div>
                <div>
                  <h1 className="text-base sm:text-lg font-black text-white uppercase tracking-tighter">
                    BEDC Tariff Schedule
                  </h1>
                  <p className="text-gray-400 text-[10px] font-black uppercase tracking-widest">
                    MYTO-2015 Framework (₦/kWh)
                  </p>
                </div>
              </div>
              <button className="bg-green-700 text-white px-5 py-2 rounded-lg font-black uppercase tracking-widest text-[10px] hover:bg-yellow-400 hover:text-black transition-all shadow-md">
                Download PDF ↓
              </button>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full border-spacing-0">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="sticky left-0 z-20 bg-gray-50 px-5 py-3 text-left text-[10px] font-black text-gray-400 uppercase tracking-widest border-b border-gray-100">
                      Class
                    </th>
                    {years.map(year => (
                      <th key={year} className="px-4 py-3 text-center text-[10px] font-black text-gray-400 uppercase tracking-widest border-b border-gray-100 min-w-[80px]">
                        {year}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-50">
                  {tariffData.map((row, idx) => (
                    <tr key={idx} className="group hover:bg-green-50 transition-colors">
                      <td className="sticky left-0 z-10 bg-white group-hover:bg-green-50 px-5 py-3 text-xs sm:text-sm font-black text-black border-r border-gray-100 uppercase">
                        {row.class}
                      </td>
                      {row.values.map((val, i) => (
                        <td key={i} className="px-4 py-3 text-xs sm:text-sm text-center tabular-nums text-gray-600 font-bold group-hover:text-black">
                          {val.toFixed(2)}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="px-5 py-4 bg-gray-50/50 flex items-start gap-2.5 text-[10px] font-bold text-gray-400 italic">
              <MdInfoOutline className="shrink-0 mt-0.5 text-green-700" size={14} />
              <span>Data source: Multi-Year Tariff Order (MYTO) for Benin Electricity Distribution Company (2015-2024).</span>
            </div>
          </div>
        </div>

        {/* Contact Strip */}
        <div className="bg-black text-white p-6 sm:p-8 rounded-xl md:rounded-2xl shadow-xl flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="text-center md:text-left">
            <h4 className="text-lg sm:text-xl font-black uppercase tracking-tight mb-1">Need clarification?</h4>
            <p className="font-medium opacity-60 text-xs sm:text-sm">Reach out to our customer care channels.</p>
          </div>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
            <div className="flex items-center gap-3 group">
              <div className="bg-[#14532d] p-2.5 rounded-lg group-hover:bg-yellow-400 transition-colors">
                <FaPhoneAlt size={14} />
              </div>
              <span className="font-black text-xs sm:text-sm">0700 000 2332</span>
            </div>
            <div className="flex items-center gap-3 group">
              <div className="bg-[#14532d] p-2.5 rounded-lg group-hover:bg-yellow-400 transition-colors">
                <FaEnvelope size={14} />
              </div>
              <span className="font-black text-[11px] sm:text-xs">customercomplaints@beninelectric.com</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Section = ({ icon, title, rows, remark }) => (
  <div className="border-b border-gray-100 last:border-none">
    {/* Section Header */}
    <div className="grid grid-cols-12 bg-gray-50 text-xs font-black text-black uppercase tracking-widest">
      <div className="col-span-12 px-5 py-3 flex items-center gap-2.5">
        <span className="text-green-700 text-base">{icon}</span>
        {title}
      </div>
    </div>

    {/* Rows */}
    {rows.map(([code, desc], index) => (
      <div
        key={index}
        className="grid grid-cols-1 md:grid-cols-12 text-xs sm:text-sm text-gray-600 border-t border-gray-100 items-center"
      >
        <div className="col-span-12 md:col-span-4 px-5 py-3 font-black text-black uppercase">{code}</div>
        <div className="col-span-12 md:col-span-4 px-5 py-3 font-bold">{desc}</div>

        {index === 0 ? (
          <div
            className="col-span-12 md:col-span-4 px-5 py-3 text-gray-400 font-medium text-[11px] sm:text-xs leading-relaxed md:border-l border-gray-100 h-full flex items-center italic"
          >
            {remark}
          </div>
        ) : (
          <div className="col-span-12 md:col-span-4 hidden md:block" />
        )}
      </div>
    ))}
  </div>
);

export default Newtariffclassification;